import React from 'react';
import { useRoutes, Navigate } from 'react-router-dom';

import baseRoutes from './routes';
import LanguageRedirect from './components/LanguageRedirect';
import LanguageLayout from './components/LanguageLayout';

const AppRouter = () => {
  const childRoutes = baseRoutes.map((route) => {
    const { path, index, component: Component } = route;

    if (index) {
      return { index: true, element: <Component /> };
    }

    return { path, element: <Component /> };
  });

  childRoutes.push({ path: '*', element: <Navigate to="404" replace /> });

  const routes = useRoutes([
    { path: '/', element: <LanguageRedirect /> },
    {
      path: '/:lang',
      element: <LanguageLayout />,
      children: childRoutes,
    },
  ]);

  return routes;
};

export default AppRouter;
